export enum WtrTabViewEnum {
    Tables = 1,
    AllOrders,
    AllBills,
  }
  